<template>
  <ul
    class="grid gap-16 grid-cols-2 mt-16 mb-24 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5"
  >
    <li
      v-for="(productVariant, index) in filterStore.products"
      :key="productVariant.key"
    >
      <ProductCard :card-data="productVariant" :card-index="index" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ListingProduct } from '~/models/ListingProduct.api.model';
const filterStore = useFilterStore();

interface Props {
  data?: ListingProduct[];
  categoryName?: string;
}

defineProps<Props>();
</script>

<style scoped></style>
